// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/lever-made-of-polyamide-pa/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteLeverMadeOfPolyamidePaEN: PageEntry = {
  id: "example.produkte-hebel-aus-polyamid-pa",
  locale: "en",
  slug: "produkte/lever-made-of-polyamide-pa",
  seo: {
    title: "Lever made of polyamide (PA) | Dietz GmbH",
    description: "Levers made of polyamide (PA) with a glass fibre content of 30% for further processing in switch systems. These components transmit movements in complex assemblies.",
  },
  type: "post",
  h1: "Lever made of polyamide (PA)",
  intro: "Levers made of polyamide (PA) with a glass fibre content of 30% for further processing in switch systems. These components transmit movements in complex assemblies.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_Hebel-_Polyamid.jpg", alt: "Lever made of polyamide (PA)", width: 800, height: 640 }
  ],
};
